import {
  SET_INDI_CHALLENGES,
  SET_INDI_CHALLENGE_PARITICIPANTS,
} from './types';
import { SetRegValueHelper, SpreadOps } from '../helper';

const initialState = {
  list: [],
  count: 0,
  participants: {
    list: [],
    count: 0,
  },
};

var temp = "";
initialState.values = SpreadOps({ ...initialState.default });

export default function (state = initialState, action) {
  switch (action.type) {

    case SET_INDI_CHALLENGES:
      return {
        ...state,
        list: action.data.list,
        count: action.data.count,
      }

    case SET_INDI_CHALLENGE_PARITICIPANTS:
      return {
        ...state,
        participants: {
          list: action.data.list,
          count: action.data.count,
        }
      }

    default:
      return state

  }
}
